
import { SET_PARENT_INFO, SET_EQUAL_TIME_PARENTS, SET_PARENT_TAX_INFO } from "../actions/types";

const initialState = {
  parents:  [
    {
      name: 'Parent 1',
      frequencyIncome: 'MONTHLY',
      hours: 40,
      grossIncome: '',
      taxes: {
        federalRate: 12,
        stateRate: 9.3
      },
      disponsableIncome: 0.00
    },{
      name: 'Parent 2',
      frequencyIncome: 'MONTHLY',
      hours: 40,
      grossIncome: '',
      taxes: {
        federalRate: 12,
        stateRate: 9.3
      },
      disponsableIncome: 0.00
    }
],
  equalTimeParents: false
}

const parentsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PARENT_INFO:
      let newParents = state.parents.slice();
      newParents[payload.index][payload.key] = payload.value!=='' ? payload.value : `Parent ${payload.index + 1}`;
      return {
        ...state,
        parents: newParents,
      }
    case SET_PARENT_TAX_INFO:
      let newParentsTaxes = state.parents.slice();
      newParentsTaxes[payload.index].taxes[payload.type] = payload.value;
      
      return {
        ...state,
        parents: newParentsTaxes,
      }
    case SET_EQUAL_TIME_PARENTS:
      return {
        ...state,
        equalTimeParents: payload,
      }
    default:
      return state;
  }
}


export default parentsReducer;